import React, { useMemo, useState } from "react";
import "./AnnouncementListFilter.scss";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { commonAction } from "../../../../../redux/features/commonSlice";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";
import ListFilterButton from "../../../buttons/ListFilterButton";
import ResetIcon from "../../../../../components/icons/ResetIcon";

// type WeekKey = "1st" | "2nd" | "3rd" | "4th";

interface Props {
  defaultYear?: number;
  defaultMonth?: number;
  // defaultWeek?: WeekKey;
  onChange?(params: { year: number; month: number | null } | null): void;
  // onChange?(params: { year: number; month: number; week: WeekKey }): void;
  rightAction?: React.ReactNode;
  showFiltersBtn?: boolean;
  reset_btn_link?: string;
  onClickRefresh?: () => void;
}

const AnnouncementListFilter: React.FC<Props> = ({
  defaultYear = new Date().getFullYear(),
  defaultMonth = new Date().getMonth(),
  // defaultWeek = "1st",
  onChange,
  rightAction,
  showFiltersBtn = true,
  onClickRefresh,
}) => {
  const years = useMemo(
    () => Array.from({ length: 6 }, (_, i) => defaultYear - 2 + i),
    [defaultYear]
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetFilter = () => {
    setYear(null);
    setMonth(null);
    setDate(null);
    onChange?.(null);

    dispatch(commonAction?.resetFilter());

    const currentParams = new URLSearchParams(window.location.search);

    const subscriptionType = currentParams.get("subscription_type");

    const newParams = new URLSearchParams();
    if (subscriptionType) {
      newParams.set("subscription_type", subscriptionType);
    }

    navigate(`/workspace/agency-announcement-post-list?${newParams.toString()}`);
  };

  const [year, setYear] = useState<number | null>(null);
  const [month, setMonth] = useState<number | null>(null);
  // const [week, setWeek] = useState<WeekKey>(defaultWeek);
  const [date, setDate] = useState<Dayjs | null>(null);

  // const fire = (y = year, m = month, w = week) =>
  //   onChange?.({ year: y, month: m, week: w });

  return (
    <div className="home-filter-bar">
      <div className="home-filter-group">
        {/* <div className="select-wrapper">
          <select
            className="filter-select"
            value={year ?? ""}
            onChange={(e) => {
              const y = e.target.value ? Number(e.target.value) : null;
              setYear(y);
              if (y !== null) {
                onChange?.({ year: y, month });
              } else {
                onChange?.(null);
              }
            }}
          >
            <option value="" disabled>
              Year
            </option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          <div className="select-icon">
            <DownArrowIcon />
          </div>
        </div>

        <div className="select-wrapper">
          <select
            className="filter-select"
            value={month ?? ""}
            onChange={(e) => {
              const m = e.target.value ? Number(e.target.value) : null;
              setMonth(m);
              if (m !== null && year !== null) {
                onChange?.({ year, month: m });
              } else {
                onChange?.(null);
              }
            }}
          >
            <option value="" disabled>
              Month
            </option>
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i} value={i}>
                {dayjs().month(i).format("MMMM")}
              </option>
            ))}
          </select>
          <div className="select-icon">
            <DownArrowIcon />
          </div>
        </div> */}
      </div>

      <div className="action-group">
        {onClickRefresh && (
          <button className="list-top-refresh-btn" onClick={onClickRefresh}>
            {/* <div className="refresh-icon">
              <ResetIcon />
            </div> */}
            <p>Reload</p>
          </button>
        )}

        <button className="reset-btn" type="button" onClick={resetFilter}>
          <ResetIcon />
          Reset&nbsp;Filters
        </button>

        {showFiltersBtn && <ListFilterButton />}
        {rightAction}
      </div>
    </div>
  );
};

export default AnnouncementListFilter;
